/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpCloudSqlResourceStorageSettings {
  /**
  * Cloud SQL disk type.
  */
  'diskType': string;
  /**
  * Disk size in gigabytes.
  */
  'diskSize': number;
  /**
  * Whether storage auto-resize is enabled.
  */
  'storageAutoResize': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "diskType",
      "baseName": "diskType",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskSize",
      "baseName": "diskSize",
      "type": "number",
      "format": ""
    },
    {
      "name": "storageAutoResize",
      "baseName": "storageAutoResize",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpCloudSqlResourceStorageSettings.attributeTypeMap;
  }

  public constructor() {
  }
}

